import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '../services/baseApi';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import brandingSlice from './slices/brandingSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    branding: brandingSlice,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/REGISTER',
          // Ignore RTK Query actions that contain non-serializable Request objects
          'baseApi/executeMutation/fulfilled',
          'baseApi/executeMutation/pending',
          'baseApi/executeMutation/rejected',
          'baseApi/executeQuery/fulfilled',
          'baseApi/executeQuery/pending',
          'baseApi/executeQuery/rejected',
        ],
        ignoredActionPaths: [
          'payload',
          'meta.arg.originalArgs',
          'meta.baseQueryMeta.request', // Request objects in RTK Query metadata
          'meta.baseQueryMeta.response', // Response objects in RTK Query metadata
        ],
        ignoredPaths: [
          'baseApi.mutations',
          'baseApi.queries',
        ],
      },
    }).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;